/**
 * Map
 *
 * @returns {{init: init}}
 */
const Map = (() => {
	// Private variables
	const DOM = {};

	// Cache DOM elements
	const cacheDOM = () => {

	};

	// Handle click event on map
	const mapClick = (event) => {
		// Prevent default action
		event.preventDefault();

		// Find the nearest ancestor <a> tag
		const anchor = event.target.closest( 'a.mapmarker' );

		// If an <a> tag is found, get the data-category attribute
		if (anchor) {
			const categoryName = anchor.getAttribute( 'data-category' );

			if (categoryName) {
				ajaxFetch( categoryName );
				anchorDown();
			} else {

			}
		} else {

		}
	};
	// Handle click event on map
	const selectClick = (event, matchedAnchor) => {
		// Prevent default action
		event.preventDefault();

		// If a matched anchor is provided, get the data-category attribute
		if (matchedAnchor) {
			const categoryName = matchedAnchor.getAttribute( 'data-category' );

			if (categoryName) {
				ajaxFetch( categoryName );
				anchorDown();
			} else {

			}
		} else {

		}
	};
	// Event listener for select change event
	const selectListener    = () => {
		const selectElement = document.querySelector( 'select' );
		if (selectElement) {
			selectElement.addEventListener(
				'change',
				(event) => {
					const selectedValue = event.target.value;
					const matchedAnchor = document.querySelector( `a.mapmarker[data-category="${selectedValue}"]` );
					if (matchedAnchor) {

						selectClick( event, matchedAnchor );
					} else {
					}
				}
			);
		} else {
		}
	};

	// Scroll down to hubs archive
	const anchorDown = () => {
		// Scroll down to the .hubs-archive element
		const hubsArchive = document.querySelector( '.hubs-wrapper' );
		if (hubsArchive) {
			hubsArchive.scrollIntoView( { behavior: 'smooth' } );
		}
	};

	// Fetch category ID based on category name
	const fetchCategoryId = (categoryName) => {
		const apiUrl      = `https://cahpr.org.uk/wp-json/wp/v2/categories?slug=${categoryName}`;

		return fetch( apiUrl )
			.then(
				response => {
					if ( ! response.ok) {
						throw new Error( 'Network response was not ok' );
					}
					return response.json();
				}
			)
			.then(
				data => {
					// Extract category ID from the response
					if (Array.isArray( data ) && data.length > 0) {
						return data[0].id;
					} else {
						throw new Error( 'Category not found' );
					}
				}
			);
	};
	const fetchCategoryName = (categoryId) => {
		const apiUrl        = `https://cahpr.org.uk/wp-json/wp/v2/categories/${categoryId}`;

		return fetch( apiUrl )
			.then(
				response => {
					if ( ! response.ok) {
						throw new Error( 'Network response was not ok' );
					}
					return response.json();
				}
			)
			.then(
				data => {
					// Extract category name from the response
					if (data && data.name) {
						return data.name;
					} else {
						throw new Error( 'Category name not found' );
					}
				}
			);
	};


	// Fetch data via AJAX
	const ajaxFetch = (categoryName) => {
		// Fetch category ID based on category name
		fetchCategoryId( categoryName )
			.then(
				categoryId => {
					// Fetch category name based on category ID
					return fetchCategoryName( categoryId )
					.then(
						categoryName => {
							return { categoryId, categoryName };
						}
					);
				}
			)
			.then(
				({ categoryId, categoryName }) => {
					// Construct the URL for fetching hubs based on the category ID
					const apiUrl = `https://cahpr.org.uk/wp-json/wp/v2/hubs?categories=${categoryId}`;
					// Make the AJAX request
					return fetch( apiUrl )
					.then(
						response => {
							if ( ! response.ok) {
								throw new Error( 'Network response was not ok' );
							}
							return response.json();
						}
					)
					.then(
						data => {
							return { data, categoryName };
						}
					);
				}
			)
			.then(
				({ data, categoryName }) => {
					// Populate .hubs-wrapper with the fetched data
					const hubsWrapper = document.querySelector( '.hubs-wrapper' );
					if (hubsWrapper) {
						// Clear previous content
						hubsWrapper.innerHTML = '';

						// Update the text content of the .region-heading
						const regionHeading = document.querySelector( '.region-heading' );
						if (regionHeading) {
							regionHeading.textContent = categoryName || 'No Category Found';
						}

						// Append new content for each post
						data.forEach(
						post => {
							// Create the required HTML structure for each post
							const postElement = document.createElement( 'div' );
							postElement.classList.add( 'hubs-single', 'block-multi__content' );
							const paragraph = document.createElement( 'p' );
							const link      = document.createElement( 'a' );
							link.classList.add( 'hubs-single__link' );
							link.textContent = post.title.rendered;
							link.href        = post.link; // Assuming the hub post has a link property
							paragraph.appendChild( link );
							postElement.appendChild( paragraph );
							// Append the post element to the hubs wrapper
							hubsWrapper.appendChild( postElement );
						}
							);
					}
				}
			)
			.catch( error => console.error( 'Error fetching hubs:', error ) );
	};

	// Event listener for click event
	const eventListener  = () => {
		window.addEventListener(
			"click",
			(event) => {
				const anchor = event.target.closest( 'a.mapmarker' );
				if (anchor) {
					mapClick( event, anchor );
				}
			}
		);

	};

	// Initialize the module
	const init = () => {
		cacheDOM();
		eventListener();
		selectListener();
	};

	// Public methods
	return {
		init,
	};
})();

export default Map;
